/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Dialog_Error_Occur_DescriptionInputs */

const en_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`If the problem persists, please return to the App and contact support (Error code: ${i?.status})`)
};

const ar_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`إذا استمرت المشكلة، يرجى العودة إلى التطبيق والاتصال بالدعم ( خطأ كود: ${i?.status})`)
};

const de_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wenn das Problem weiterhin besteht, kehren Sie bitte zur App zurück und kontaktieren Sie den Support (Fehlercode: ${i?.status})`)
};

const es_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si el problema persiste, vuelva a la app y ponte en contacto con el servicio de asistencia (Código de error: ${i?.status}).`)
};

const fr_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si le problème persiste, retournez dans l'application et contactez l'assistance (Code d'erreur : ${i?.status})`)
};

const it_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se il problema persiste, torna all'app e contatta l'assistenza (Codice errore: ${i?.status})`)
};

const ja_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`問題が解決しない場合はアプリに戻り、サポートにお問い合わせください（エラーコード：${i?.status}）`)
};

const ko_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`문제가 지속되면 앱으로 돌아가 고객센터로 문의하세요(오류 코드: ${i?.status})`)
};

const pt_br_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se o problema persistir, retorne ao aplicativo e contate o suporte (Código do erro: ${i?.status})`)
};

const ru_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Если проблема не устранится, вернитесь в приложение и обратитесь в службу поддержки (код ошибки: ${i?.status})`)
};

const th_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`หากปัญหายังคงอยู่ โปรดกลับไปที่แอปและติดต่อฝ่ายสนับสนุน (รหัสข้อผิดพลาด: ${i?.status})`)
};

const tr_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sorun devam ederse, lütfen uygulamaya dön ve Müşteri Hizmetleriyle iletişime geç (Hata kodu: ${i?.status})`)
};

const zh_cn_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`若问题持续发生，请回到 App 联系客服（错误代码：${i?.status}）`)
};

const zh_tw_dialog_error_occur_description = /** @type {(inputs: Dialog_Error_Occur_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`若問題持續發生，請回到 App 聯繫客服（錯誤代碼：${i?.status}）`)
};

/**
* | output |
* | --- |
* | "If the problem persists, please return to the App and contact support (Error code: {status})" |
*
* @param {Dialog_Error_Occur_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_error_occur_description = /** @type {((inputs: Dialog_Error_Occur_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Error_Occur_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_error_occur_description(inputs)
	if (locale === "ar") return ar_dialog_error_occur_description(inputs)
	if (locale === "de") return de_dialog_error_occur_description(inputs)
	if (locale === "es") return es_dialog_error_occur_description(inputs)
	if (locale === "fr") return fr_dialog_error_occur_description(inputs)
	if (locale === "it") return it_dialog_error_occur_description(inputs)
	if (locale === "ja") return ja_dialog_error_occur_description(inputs)
	if (locale === "ko") return ko_dialog_error_occur_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_error_occur_description(inputs)
	if (locale === "ru") return ru_dialog_error_occur_description(inputs)
	if (locale === "th") return th_dialog_error_occur_description(inputs)
	if (locale === "tr") return tr_dialog_error_occur_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_error_occur_description(inputs)
	return zh_tw_dialog_error_occur_description(inputs)
});